// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3lSFJ","errorLogs":"styles_errorLogs__2WURG"};